import {
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    IconButton,
    Typography,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import { React, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FormBox from "../../component/FormBox/FormBox";
import { getCurrentStep, getFormId } from "../../redux/selector";

import "./StepHeader.scss";

export default function StepHeader({
    title,
    step,
    mandatory = true,
    notesTips = false,
}) {
    const { t, i18n } = useTranslation();
    const [popToolTip, setPopToolTip] = useState(false);
    const formId = useSelector(getFormId());
    const currentStep = useSelector(getCurrentStep());

    if (currentStep === "FormExpired") {
        mandatory = false;
    }

    const onClose = () => {
        setPopToolTip(false);
    };

    return (
        <Box>
            <Box className="stepHeader">
                <Typography component={"div"} className="stepIndicator">
                    {t("common.step", {
                        step:
                            formId === "Form101"
                                ? Math.trunc(Number(step)) + 1
                                : step + 1,
                    })}
                </Typography>
                <Typography component={"div"} className="stepTitle">
                    {title}
                </Typography>
            </Box>
            {notesTips &&
                (formId === "Form096" ? (
                    <Box>
                        <Box
                            component="span"
                            sx={{}}
                            fontSize={16}
                            fontWeight={700}
                        >
                            {t(`Form096.tooltip.notesTips`)}
                        </Box>
                        <Box
                            component="span"
                            onClick={(event) => {
                                event.stopPropagation();
                                setPopToolTip(true);
                            }}
                            sx={{
                                position: "relative",
                                top: "6px",
                            }}
                        >
                            <InfoIcon />
                        </Box>
                    </Box>
                ) : (
                    <Box
                        fontWeight={700}
                        dangerouslySetInnerHTML={{ __html: notesTips }}
                        style={{ marginTop: "-10px", marginBottom: "5px" }}
                    ></Box>
                ))}
            {mandatory && (
                <Typography variant="body2" className="manda">
                    <Box component="span" className="danger">
                        *
                    </Box>
                    {`: ${t("common.mandatory")}`}
                </Typography>
            )}
            <Dialog open={popToolTip} onClose={onClose} scroll={"body"}>
                <IconButton
                    aria-label="cancel"
                    style={{
                        position: "absolute",
                        right: "4px",
                        top: "4px",
                        padding: "3px",
                    }}
                    onClick={onClose}
                >
                    <Close />
                </IconButton>
                <DialogContent
                    style={{
                        padding: "2rem",
                    }}
                >
                    <DialogContentText>
                        <form className="form96">
                            <FormBox header={t(`Form096.notes.notesTitle`)}>
                                <Box p={5} className="notes-body">
                                    {Object.entries(
                                        t(`Form096.noteList`, {
                                            returnObjects: true,
                                        })
                                    ).map(([keys, value]) => {
                                        return (
                                            <Typography
                                                className="notes-item"
                                                key={`note${keys}`}
                                            >
                                                <span className="notes-serial">
                                                    {Number(keys) + 1}
                                                    {". "}
                                                </span>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: value,
                                                    }}
                                                ></span>
                                                {keys == 6 && (
                                                    <Box className="body-child">
                                                        {Object.entries(
                                                            t(`Form096.note7`, {
                                                                returnObjects: true,
                                                            })
                                                        ).map(([idx, val]) => (
                                                            <Box
                                                                className="notes-item"
                                                                key={`noteChild${idx}`}
                                                            >
                                                                <span className="notes-serial">
                                                                    {t(
                                                                        `Form096.serial.num${idx}`
                                                                    )}
                                                                </span>
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: val,
                                                                    }}
                                                                ></span>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                )}
                                                {keys == 12 && (
                                                    <Box className="body-child">
                                                        {Object.entries(
                                                            t(
                                                                `Form096.note13`,
                                                                {
                                                                    returnObjects: true,
                                                                }
                                                            )
                                                        ).map(([idx, val]) => (
                                                            <Box
                                                                className="notes-item"
                                                                key={`noteChild${idx}`}
                                                            >
                                                                <span className="notes-serial">
                                                                    {t(
                                                                        `Form096.serial.num${idx}`
                                                                    )}
                                                                </span>
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: val,
                                                                    }}
                                                                ></span>
                                                                {idx == 0 && (
                                                                    <Box className="body-child">
                                                                        {Object.entries(
                                                                            t(
                                                                                `Form096.note13A`,
                                                                                {
                                                                                    returnObjects: true,
                                                                                }
                                                                            )
                                                                        ).map(
                                                                            ([
                                                                                idx,
                                                                                val,
                                                                            ]) => (
                                                                                <Box
                                                                                    className="notes-item"
                                                                                    key={`noteChild${idx}`}
                                                                                >
                                                                                    <span
                                                                                        className="notes-serial"
                                                                                        style={{
                                                                                            fontFamily:
                                                                                                "Arial",
                                                                                        }}
                                                                                    >
                                                                                        {t(
                                                                                            `Form096.serialChild.num${idx}`
                                                                                        )}
                                                                                    </span>
                                                                                    <span
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: val,
                                                                                        }}
                                                                                    ></span>
                                                                                </Box>
                                                                            )
                                                                        )}
                                                                    </Box>
                                                                )}
                                                                {idx == 2 && (
                                                                    <Box className="body-child">
                                                                        {Object.entries(
                                                                            t(
                                                                                `Form096.note13C`,
                                                                                {
                                                                                    returnObjects: true,
                                                                                }
                                                                            )
                                                                        ).map(
                                                                            ([
                                                                                idx,
                                                                                val,
                                                                            ]) => (
                                                                                <Box
                                                                                    className="notes-item"
                                                                                    key={`noteChild${idx}`}
                                                                                >
                                                                                    <span
                                                                                        className="notes-serial"
                                                                                        style={{
                                                                                            fontFamily:
                                                                                                "Arial",
                                                                                        }}
                                                                                    >
                                                                                        {t(
                                                                                            `Form096.serialChild.num${idx}`
                                                                                        )}
                                                                                    </span>
                                                                                    <span
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: val,
                                                                                        }}
                                                                                    ></span>
                                                                                </Box>
                                                                            )
                                                                        )}
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                )}
                                            </Typography>
                                        );
                                    })}
                                </Box>
                            </FormBox>
                        </form>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </Box>
    );
}
